import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
// import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
// import IMG5 from '../../assets/portfolio5.png'

const Portfolio = () => {

  const data = [
    {
      id: 1,
      image: IMG1,
      title: "Report sexual violence and harrasment in Universities",
      github: "https://github.com/report_and_support",
      demo: "https://myvoice.maseno.ac.ke"
    },
    {
      id: 2,
      image: "https://botscrew.com/wp-content/uploads/2022/03/SMS-Chatbots-Cover-Image-min.jpg",
      title: "School timetable chatbot application",
      github: "https://github.com/simonwandera/Timetable-chatbot",
      demo: "https://simoh.pythonanywhere.com"
    },
    {
      id: 3,
      image: IMG3,
      title: "Savings and loans web application",
      github: "https://github.com/loans_and_savings",
      demo: "#"
    },
    {
      id: 4,
      image: IMG4,
      title: "Modern blog application",
      github: "https://github.com/report_and_support",
      demo: "https://simonwandera.github.io/ninja-todo-app"
    }
  ]
  return (
    <section id='portfolio'>
      <h5>My recent work</h5>
      <h2>Portfolio</h2>

      <div className='container portfolio__container'>

        {
          data.map(({ id, image, title, github, demo }) => {
            return (
              <article className='portfolio__item' key={id}>
                <div className='portfolio__item-image'>
                  <img src={image} alt={title} />
                </div>
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  <a href={github} className='btn' target='_blank'>Github</a>
                  <a href={demo} className='btn' target='_blank'>Live Demo</a>
                </div>
              </article>
            )
          }
          )
        }

      </div>
    </section>
  )
}

export default Portfolio
